import React, { useEffect, useRef } from 'react';
import _ from 'lodash';

const ListItem = ({
  keyValue,
  setFocus,
  index,
  focus,
  className,
  onClick,
  type,
  item,
  displayKey,
  toLower
}) => {
  const ref = useRef(null);
  let displayValue = item[displayKey];
  let setValue = item[displayKey];
  let brandDiv = '';
  if (type === 'brand') {
    setValue = item;
    brandDiv = (
      <div className="brand-type">
        (
        {item?.drugType ? item?.drugType : item.isGeneric ? 'Generic' : 'Brand'}
        )
      </div>
    );
  }

  useEffect(() => {
    if (focus) {
      // Move element into view when it is focused
      ref.current.focus();
    }
  }, [focus]);

  const handleSelect = () => {
    // setting focus to that element when it is selected
    setFocus(index);
    //ref.current.focus();
    onClick(type, setValue);
  };

  const handleOnKeyPress = event => {
    if (event.key === 'Enter') {
      handleSelect();
    }
  };

  return (
    <div
      id={item?.id ? item?.id : `item-${index}`}
      tabIndex={focus ? 0 : -1}
      ref={ref}
      key={keyValue}
      className={`custom-option ${className === setValue && ' selected'}`}
      data-value={displayValue}
      onClick={handleSelect}
      onKeyPress={handleOnKeyPress}
      role="option"
    >
      <span>{toLower === 'true' ? _.toLower(displayValue) : displayValue}</span>
      {brandDiv}
    </div>
  );
};

export default ListItem;
